import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { delay } from "@Shared/utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InlinePrompt",
  components: {
    SimpleButton
  },
  props: {
    actionType: {
      type: String,
      default: "delete",
      validator(value) {
        const validActions = ["add", "edit", "delete"];
        return _includesInstanceProperty(validActions).call(validActions, value);
      }
    },
    actionText: {
      type: String,
      default: ""
    },
    acceptTextClass: {
      type: String,
      default: ""
    },
    actionClassText: {
      type: String,
      default: ""
    },
    acceptType: {
      type: String,
      default: "icon",
      validator(value) {
        const validTypes = ["text", "icon"];
        return _includesInstanceProperty(validTypes).call(validTypes, value);
      }
    },
    acceptContent: {
      type: String,
      default: "check"
    },
    dismissType: {
      type: String,
      default: "icon",
      validator(value) {
        const validTypes = ["text", "icon"];
        return _includesInstanceProperty(validTypes).call(validTypes, value);
      }
    },
    dismissContent: {
      type: String,
      default: "times"
    },
    confirmationText: {
      type: String,
      default: null
    },
    confirmationTextClass: {
      type: String,
      default: ""
    },
    placement: {
      type: String,
      default: "top"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    container: {
      type: null,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    },
    acceptButtonType: {
      type: String,
      default: "danger"
    },
    confirmationTextColor: {
      type: String,
      default: "text-gray"
    }
  },
  data() {
    return {
      prompting: false,
      componentReady: false,
      open: false
    };
  },
  computed: {
    actionClassIcon() {
      if (this.actionType === "delete") return "fa-trash text-danger";
      throw new Error("Not Implemented");
    },
    acceptClass() {
      return `fa-${this.acceptContent}`;
    },
    dismissClass() {
      return `fa-${this.dismissContent}`;
    },
    confirmationTextToUse() {
      const confirmationText = this.confirmationText || this.$t("global.actions.confirmDeletion");
      if (_includesInstanceProperty(confirmationText).call(confirmationText, "i18n|")) return this.$t(confirmationText.split("i18n|")[1]);
      return confirmationText;
    }
  },
  beforeDestroy() {
    this.open = false;
  },
  mounted() {
    this.$nextTick(() => {
      this.componentReady = true;
    });
  },
  methods: {
    handleShow() {
      this.open = true;
      this.handleActionClick();
    },
    handleHide($event) {
      if (this.loading) {
        $event.preventDefault();
      } else {
        this.open = false;
      }
      this.handleDismissClick();
    },
    async handleAcceptClick() {
      if (!this.loading) {
        this.open = false;
        await delay(150);
      }
      this.$emit("accept");
    },
    handleDismissClick() {
      if (!this.loading) this.open = false;
      this.$emit("dismiss");
    },
    handleActionClick() {
      this.$emit("prompt");
    }
  }
});